// SPDX-FileCopyrightText: Copyright Orangebot, Inc. and Medplum contributors
// SPDX-License-Identifier: Apache-2.0

const STORAGE_KEY_PREFIX = 'polaris-intake-consent-signature:';
const AGREEMENT_STORAGE_KEY_PREFIX = 'polaris-intake-consent-agreement:';
const RELATIONSHIP_STORAGE_KEY_PREFIX = 'polaris-intake-consent-relationship:';

function getStorageKey(uniqueId: string): string {
  return `${STORAGE_KEY_PREFIX}${uniqueId}`;
}

function getAgreementStorageKey(uniqueId: string): string {
  return `${AGREEMENT_STORAGE_KEY_PREFIX}${uniqueId}`;
}

function getRelationshipStorageKey(uniqueId: string): string {
  return `${RELATIONSHIP_STORAGE_KEY_PREFIX}${uniqueId}`;
}

/** Stores the signed name only long enough to bridge the onboarding page redirect. */
export function storeIntakeConsentSignature(
  uniqueId: string,
  signature: string,
  agreementPdfBase64?: string,
  relationship?: string
): void {
  sessionStorage.setItem(getStorageKey(uniqueId), signature);
  if (agreementPdfBase64) {
    sessionStorage.setItem(getAgreementStorageKey(uniqueId), agreementPdfBase64);
  }
  if (relationship) {
    sessionStorage.setItem(getRelationshipStorageKey(uniqueId), relationship);
  }
}

export function getIntakeConsentAgreement(uniqueId: string): string | undefined {
  return sessionStorage.getItem(getAgreementStorageKey(uniqueId)) ?? undefined;
}

/** Returns the pending signature for an onboarding flow, if one exists. */
export function getIntakeConsentSignature(uniqueId: string): string | undefined {
  return sessionStorage.getItem(getStorageKey(uniqueId)) ?? undefined;
}

export function getIntakeConsentRelationship(uniqueId: string): string | undefined {
  return sessionStorage.getItem(getRelationshipStorageKey(uniqueId)) ?? undefined;
}

/** Removes the temporary handoff value after the eligibility bot accepts it. */
export function clearIntakeConsentSignature(uniqueId: string): void {
  sessionStorage.removeItem(getStorageKey(uniqueId));
  sessionStorage.removeItem(getAgreementStorageKey(uniqueId));
  sessionStorage.removeItem(getRelationshipStorageKey(uniqueId));
}
